export default {
    isAppointmentStatusFormOpen: state => state.appointmentStatusFormIsOpen,
    isAppointmentStatusGridOpen: state => state.appointmentStatusGridIsOpen,

    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getSearchFields: state => state.searchFields

}